import { render, staticRenderFns } from "./RequirementsTable.vue?vue&type=template&id=140d04d8&scoped=true&"
import script from "./RequirementsTable.vue?vue&type=script&lang=js&"
export * from "./RequirementsTable.vue?vue&type=script&lang=js&"
import style0 from "./RequirementsTable.vue?vue&type=style&index=0&id=140d04d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140d04d8",
  null
  
)

export default component.exports